import React, {Suspense} from 'react';
import {
  Dimensions,
  Image,
  Platform,
  StatusBar,
  StyleSheet,
  View,
} from 'react-native';
import {SafeAreaProvider, SafeAreaView} from 'react-native-safe-area-context';
import {useSelector} from 'react-redux';
import FaJson from 'src/i18n/fa-IR.json';
import {isWeb} from '../../constants';
import {Redirect, Route, Switch} from '../../imports/Router';
import Sentry from 'src/imports/sentry';
import {lazyWithRetry} from '../../utils/lazyWithRetry';
const EndTripImage = lazyWithRetry(() =>
  import('../../pages/end-trip-image/EndTripImage.component'),
);
const DangerousRide = lazyWithRetry(() => import('src/pages/dangerous-ride'));
const Scanner = lazyWithRetry(() =>
  import('../../pages/scanner/Scanner.component'),
);
const SerialNumber = lazyWithRetry(() =>
  import('../../pages/serial-number/SerialNumber.component'),
);
import {colorPalette} from '../../theme';
import {customResponsiveWidth} from '../../utils/CustomResponsive';
import FallbackError from '../fallback-error/FallbackError.component';
import LoadSplash from '../loadsplash/LoadSplash.component';
import {CustomText} from '../text/Text';
const Updating = lazyWithRetry(() =>
  import('../../pages/updating/Updating.component'),
);
const PaymentSuccess = lazyWithRetry(() =>
  import('../../pages/payment-status/payment-success/PaymentSuccess.component'),
);
const PaymentError = lazyWithRetry(() =>
  import('../../pages/payment-status/payment-error/PaymentError.component'),
);
const IconHub = lazyWithRetry(() => import('src/pages/icon-hub/IconHub'));
const PayDebt = lazyWithRetry(() =>
  import('../../pages/pay-debt/PayDebt.component'),
);
const ConfirmDangerRide = lazyWithRetry(() =>
  import('../../pages/confirm-danger-ride/ConfirmDangerRide'),
);
const Logout = lazyWithRetry(() => import('../../pages/logout'));
const Register = lazyWithRetry(() => import('./Register.component'));
const Signed = lazyWithRetry(() => import('./Signed.component'));
const Auth = lazyWithRetry(() => import('./Auth.component'));
const NewVersion = lazyWithRetry(() =>
  import('../../pages/sepecials/new-version/NewVersion.component'),
);
import TripLearning from '../../pages/trip-learning/TripLearning'
import usePushNotif from 'src/hooks/usePushNotif';
import { useUserLocationInterval } from '../../hooks/useUserLocationInterval';
const Payment = lazyWithRetry(() =>
  import('../../pages/payment/Payment.component'),
);
const windowHeight = Dimensions.get('window').height;

const Routes = () => {
  const {landscapeView} = useSelector(state => state.app);
  usePushNotif()
  useUserLocationInterval()
  

  if (isWeb && landscapeView) {
    return (
      <View style={styles.orientationContainer}>
        <Image
          style={styles.orientaionImage}
          source={require('src/assets/images/orientation.png')}
        />
        <CustomText size={18} font="700">
          {FaJson.please_change_device_orientation}
        </CustomText>
      </View>
    );
  }

  return (
    <>
      <SafeAreaProvider style={{flex: 1}}>
        <SafeAreaView
          style={{flex: 1}}
          mode="padding"
          edges={['right', 'left', 'top']}>
          <View style={{
            height: isWeb ? windowHeight : undefined , 
            flex : isWeb ? undefined : 1
            }}>
            <StatusBar
              backgroundColor={colorPalette.whiteGrey0}
              barStyle="dark-content"
            />
            <Switch>
              <Suspense fallback={() => {}}>
                <Sentry.ErrorBoundary fallback={<FallbackError />}>
                  <Route
                    path={['/']}
                    exact
                    render={() => <Redirect to={'/splash'} />}
                  />
                  <Route path={['/splash']} render={() => <LoadSplash />} />
                  <Route path={['/main']} render={() => <Signed />} />
                  <Route path={['/register']} render={() => <Register />} />
                  <Route path={['/auth']} render={() => <Auth />} />
                  <Route path={['/newversion']} component={NewVersion} />
                  <Route path={['/logout']} component={Logout} />
                  <Route path={['/updating']} component={Updating} />
                  <Route path={['/scanner']} component={Scanner} />
                  <Route path={['/serial-number']} component={SerialNumber} />
                  <Route path={['/end-trip-image']} component={EndTripImage} />
                  <Route path={['/payment']} component={Payment} />
                  <Route path={['/pay-debt']} component={PayDebt} />
                  <Route path={['/trip-learn']} component={TripLearning} />
                  <Route path={['/icon-hub']} component={IconHub} />
                  <Route path={'/dangerous-ride'} component={DangerousRide}/>
                  <Route path={'/confirm-danger-ride'} component={ConfirmDangerRide}/>
                  <Route
                  path={['/payment-success']}
                    component={PaymentSuccess}
                  />
                  <Route path={['/payment-error']} component={PaymentError} />
                </Sentry.ErrorBoundary>
              </Suspense>
            </Switch>
          </View>
        </SafeAreaView>
      </SafeAreaProvider>
    </>
  );
};
export default Routes;

const styles = StyleSheet.create({
  orientationContainer: {
    height: customResponsiveWidth(100),
    width: '100%',
    alignItems: 'center',
  },
  orientaionImage: {
    marginTop: customResponsiveWidth(25),
    marginBottom: 10,
    width: customResponsiveWidth(40),
    height: customResponsiveWidth(33),
  },
});

